import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { getCacheDuration } from '../../../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../../../utils/load-data-from-api';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
export const loadMemberPaymentCards = async () => {
    if (!isMemberSignedIn())
        throw new Error('No user is signed in');
    const state = temporaryLoyaltyDomainStore.data.memberPaymentCards;
    await loadDataFromApi({
        api: ocapiClient.instance.v1.loyalty.members.paymentCards.getAll,
        state,
        cacheDuration: getCacheDuration('member'),
        onSuccess: response => response.cards
    });
};
